import React from 'react';
import { Star } from 'lucide-react';
import { testimonials } from '../data/mockData';

const Testimonials = () => {
  return (
    <div>
      {/* Hero Section */}
      <section style={{ 
        background: 'var(--bg-secondary)',
        padding: '80px 0',
        borderBottom: '1px solid var(--border-light)'
      }}>
        <div className="container">
          <h1 className="hero-large" style={{ marginBottom: '16px' }}>
            Patient Testimonials
          </h1>
          <p className="body-large" style={{ color: 'var(--text-secondary)' }}>
            Real experiences from real patients at The Eternal Care
          </p>
        </div>
      </section>

      {/* Testimonials Grid */}
      <section className="section-padding">
        <div className="container">
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))',
            gap: '32px'
          }}>
            {testimonials.map((testimonial) => (
              <div 
                key={testimonial.id}
                style={{
                  background: 'var(--bg-primary)',
                  padding: '40px',
                  borderRadius: '0px',
                  border: '1px solid var(--border-light)',
                  display: 'flex',
                  flexDirection: 'column'
                }}
              >
                <div style={{ display: 'flex', gap: '4px', marginBottom: '20px' }}>
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Star 
                      key={i} 
                      size={18} 
                      fill="var(--text-primary)" 
                      color="var(--text-primary)" 
                    />
                  ))}
                </div>

                <p className="body-large" style={{ 
                  marginBottom: '24px',
                  lineHeight: '1.7',
                  color: 'var(--text-primary)',
                  flex: 1
                }}>
                  "{testimonial.text}"
                </p>

                <div style={{ 
                  paddingTop: '24px',
                  borderTop: '1px solid var(--border-light)'
                }}>
                  <div className="heading-3" style={{ marginBottom: '4px' }}>
                    {testimonial.name}
                  </div>
                  <div className="body-small" style={{ 
                    color: 'var(--text-secondary)',
                    marginBottom: '8px'
                  }}>
                    {testimonial.location}
                  </div>
                  <div style={{
                    display: 'inline-block',
                    padding: '4px 12px',
                    background: 'var(--bg-secondary)',
                    border: '1px solid var(--border-light)',
                    borderRadius: '0px',
                    marginTop: '8px'
                  }}>
                    <span className="body-small" style={{ color: 'var(--text-primary)' }}>
                      {testimonial.treatment}
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section style={{ background: 'var(--bg-secondary)' }} className="section-padding">
        <div className="container">
          <div style={{
            maxWidth: '700px',
            margin: '0 auto',
            textAlign: 'center'
          }}>
            <h2 className="hero-medium" style={{ marginBottom: '16px' }}>
              Join Our Happy Patients
            </h2>
            <p className="body-large" style={{ 
              marginBottom: '32px',
              color: 'var(--text-secondary)'
            }}>
              Experience the same quality care and painless treatment that our patients rave about
            </p>
            <a href="/book-appointment" className="btn-primary">
              Book Your Appointment
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Testimonials;
